<template>
  <AnnouncementList
    :fetch-fn="fetchAllAnnouncements"
    :back-link="$currentModule.getRoute()"
  />
</template>

<script>
import AnnouncementList from '@components/announcement/announcement-list'
import { getAnnouncementForRequesterApi } from '@modules/organization/announcement-api'
export default {
  name: 'AllAnnouncements',
  components: { AnnouncementList },
  methods: {
    fetchAllAnnouncements(...args) {
      return getAnnouncementForRequesterApi(...args)
    },
  },
}
</script>
